const filterNames = function () {
  return [
    'name',
    'categories',
    'all_enabled_categories',
    'prices',
    'food-types',
    'shore-distance',
    'distance',
    'distance-to-ski-lift',
    'waters',
    'camp-service-tags',
    'apartment-service-tags',
    'childcare-tags',
    'camp_treatment_profiles',
    'camp-locations',
    'camp-promotions',
    'suitable-tags-for-recovery',
    'page',
    'camp_id',
    'sight_id',
    'sight',
    'instant',
    'recovery',
    'treatment-profiles-tags',
    'tags_properties',
    'swimming_pools_properties',
    'districts',
    'bath-tags',
    'less_capacity',
  ];
};

export { filterNames };
